import { Navigate } from 'react-router-dom';
import { useAppContext } from '../components/context/AppContext';

const ProtectedRoute = ({ requiredRole, requiredPermission, children }) => {
  const { user, loading } = useAppContext();
  console.log("in protected route");
  console.log(user);
  console.log(loading);

  // Wait until `AuthProvider` completes its authentication check
  if (loading) {
    return null; // Return nothing or a loading spinner while waiting
  }

  // If no user is logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" />;
  }

  const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
  const fallback = () => (
    user.role === 'admin' || user.role === 'staff' ? (
      <Navigate to="/admin/dashboard" />
    ) : (
      user.role === 'dealer' ?
        <Navigate to="/dealer/dashboard" />
        :
        <Navigate to="/patient/dashboard" />
    )
  );

  // Check role-based access
  if (requiredRole && !allowedRoles.includes(user.role)) {
    return fallback();
  }

  // Screen-level access: only meaningful for role:"staff" - a full admin
  // always has every screen, a staff account only has what's in permissions[].
  if (requiredPermission && user.role === 'staff' && !user.permissions?.includes(requiredPermission)) {
    return fallback();
  }

  return children; // Render protected content if authenticated and authorized
};

export default ProtectedRoute;
